import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const setupPwa = () => {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__pwaPrompt = e;
    window.dispatchEvent(new Event("pwa-prompt-ready"));
  });
  window.addEventListener("appinstalled", () => {
    window.__pwaPrompt = null;
    trackInstall("install");
    subscribePush().catch(() => {});
  });
  if (window.matchMedia("(display-mode: standalone)").matches && !localStorage.getItem("pwa_launch_tracked")) {
    localStorage.setItem("pwa_launch_tracked", "1");
    trackInstall("launch");
  }
};

export const trackInstall = async (event) => {
  try {
    await axios.post(`${API}/app/installs`, {
      event,
      platform: navigator.userAgent || "",
      langue: navigator.language || "",
    });
  } catch {}
};

export const canPromptInstall = () => Boolean(window.__pwaPrompt);

export const isInstalled = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const promptInstall = async () => {
  const promptEvent = window.__pwaPrompt;
  if (!promptEvent) return null;
  promptEvent.prompt();
  const choice = await promptEvent.userChoice;
  window.__pwaPrompt = null;
  return choice.outcome;
};

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
};

export const subscribePush = async () => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return false;
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return false;
  const reg = await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/app/vapid-key`);
  const existing = await reg.pushManager.getSubscription();
  const sub = existing || (await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.publicKey),
  }));
  await axios.post(`${API}/app/push/subscribe`, sub.toJSON());
  return true;
};
